import { Businesses } from '@just-in-types';
import { firestore } from '../firebase';

export default async () => {
  const hebronSnapshot = await firestore
    .collection('businesses')
    .doc('ZfaZZTjo9zJz0XwYe8Fn')
    .get();
  const hebronData = hebronSnapshot.data() as Businesses.Site;
  const { theme } = hebronData;
  const businessesQuery = await firestore.collection('businesses').get();
  const batch = firestore.batch();
  let updateCount = 0;

  businessesQuery.forEach(businessDoc => {
    const businessRef = businessDoc.ref;
    const businessData = businessDoc.data() as Businesses.Business;

    if (!businessData.theme) {
      updateCount++;
      batch.set(businessRef, { theme }, { merge: true });
    }
  });

  await batch.commit();

  return `${updateCount} themes copied!`;
};



// WEBPACK FOOTER //
// ./src/adminFunctions/copyBesslerTheme.ts